import { FILTERS } from '../../constants/filters';
import { FDealType, FOfferType } from '../../utils/category';

export const FILTERS_TYPES: { dealType: FDealType, offerType: FOfferType, list: (keyof typeof FILTERS)[] }[] = [
  {
    dealType: FDealType.Any,
    offerType: FOfferType.Flat,
    list: [ 'offerType', 'roomType', 'price', 'geo' ],
  },
  {
    dealType: FDealType.Any,
    offerType: FOfferType.Urban & ~FOfferType.Flat,
    list: [ 'offerType', 'price', 'geo' ],
  },
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Suburban,
    list: [ 'offerType', 'posessor', 'price', 'geo' ],
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Suburban,
    list: [ 'offerType', 'price', 'geo' ],
  },
  {
    dealType: FDealType.RentDaily,
    offerType: FOfferType.Suburban,
    list: [ 'offerType', 'bedrooms', 'price', 'geo' ],
  },
  {
    dealType: FDealType.Sale | FDealType.RentLongterm,
    offerType: FOfferType.Commercial & ~FOfferType.CommercialLand,
    list: [ 'offerType', 'price', 'area', 'geo' ],
  },
  {
    dealType: FDealType.Any,
    offerType: FOfferType.CommercialLand,
    list: [ 'offerType', 'price', 'landArea', 'geo' ],
  },
];

export function getFiltersList(dealType: FDealType, offerType: FOfferType): (keyof typeof FILTERS)[] {
  const type = FILTERS_TYPES.find((t) => (t.dealType & dealType) !== 0 && (t.offerType & offerType) !== 0);

  return type && type.list || [];
}
